import z from "zod";

/**
 * ReportAssistenciaTecnicaSchema
 */

export const ReportAssistenciaTecnicaSchema = z.object({
  codigo: z.coerce.number().nullable().default(null).transform(value => !value ? null : value),
  nroChamado: z.string().nullable().default(null).transform(value => !value || value.trim().length === 0 ? null : value),
  status: z.coerce.number().nullable().default(null),
  dataAbertura: z.array(z.coerce.date().nullable()).nullable().default(null),
  unidade: z.string().nullable().default(null),
  procedente: z.array(z.number()).default([]),
  categoria: z.array(z.string()).default([]),
  resolvido: z.array(z.number()).default([]),
  dataEncerramento: z.array(z.coerce.date().nullable()).nullable().default(null),
  clientes: z.array(z.number()).default([]),
  centroCustos: z.array(z.number()).default([]),
  prioridade: z.array(z.number()).default([]),
});

/**
 * ReportAssistenciaTecnicaForm
 */

export type ReportAssistenciaTecnicaForm = z.infer<typeof ReportAssistenciaTecnicaSchema>;